/* ==========================================================================
   MONARO — Landing de conversión · JS único, sin dependencias.
   Cubre: drawer de menú, carriles, FAQ, selector de packs, swatches,
   sticky CTA, toast y alta en el carrito de Shopify vía AJAX (/cart/add.js).
   Todo delegado en document, así que funciona aunque el Theme Editor
   vuelva a renderizar una sección.
   ========================================================================== */
(function () {
  'use strict';

  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* ---------- Toast ---------------------------------------------------- */
  var toastTimer;
  function toast(msg) {
    var t = $('#m-toast');
    if (!t) {
      t = document.createElement('div');
      t.id = 'm-toast';
      t.className = 'm-toast';
      t.setAttribute('role', 'status');
      t.setAttribute('aria-live', 'polite');
      document.body.appendChild(t);
    }
    t.textContent = msg;
    t.classList.add('is-on');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { t.classList.remove('is-on'); }, 2600);
  }

  /* ---------- Menú lateral --------------------------------------------- */
  function setDrawer(open) {
    var d = $('#m-drawer');
    if (!d) return;
    var btn = $('[data-m-menu]');
    if (open) {
      d.hidden = false;
      requestAnimationFrame(function () { d.classList.add('is-open'); });
      var first = d.querySelector('a,button');
      if (first) setTimeout(function () { first.focus(); }, 120);
    } else {
      d.classList.remove('is-open');
      setTimeout(function () { d.hidden = true; }, 300);
      if (btn) btn.focus();
    }
    if (btn) btn.setAttribute('aria-expanded', String(open));
    document.documentElement.style.overflow = open ? 'hidden' : '';
  }

  /* ---------- Carrito de Shopify --------------------------------------- */
  function cartRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }
  function refreshCartCount() {
    fetch(cartRoot() + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        $$('[data-m-cart-count]').forEach(function (el) { el.textContent = c.item_count; });
      })
      .catch(function () { /* sin carrito disponible (previsualización) */ });
  }
  function addToCart(variantId, qty, label, btn) {
    if (!variantId) { toast('Selecciona primero una variante.'); return; }
    if (btn) { btn.disabled = true; btn.dataset.vLabel = btn.textContent; btn.textContent = 'Añadiendo…'; }
    fetch(cartRoot() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: Number(qty || 1) }] })
    })
      .then(function (r) { return r.json().then(function (b) { return { ok: r.ok, body: b }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.body && res.body.description || 'Error');
        toast('Añadido: ' + (label || 'producto'));
        refreshCartCount();
        document.dispatchEvent(new CustomEvent('monaro:added', { detail: res.body }));
      })
      .catch(function (e) { toast(e.message || 'No se pudo añadir al carrito.'); })
      .finally(function () {
        if (btn) { btn.disabled = false; btn.textContent = btn.dataset.vLabel || 'Añadir'; }
      });
  }

  /* ---------- Delegación global ---------------------------------------- */
  document.addEventListener('click', function (e) {
    var el;

    /* Menú */
    if (e.target.closest('[data-m-menu]')) { setDrawer(true); return; }
    if (e.target.closest('[data-m-close]')) { setDrawer(false); return; }
    if (e.target.closest('#m-drawer a')) { setDrawer(false); }

    /* Carril */
    el = e.target.closest('[data-m-rail-dir]');
    if (el) {
      var track = document.getElementById(el.getAttribute('data-m-rail-target'));
      if (track) {
        track.scrollBy({
          left: Number(el.getAttribute('data-m-rail-dir')) * Math.min(track.clientWidth * 0.8, 540),
          behavior: 'smooth'
        });
      }
      return;
    }

    /* FAQ */
    el = e.target.closest('[data-m-faq-q]');
    if (el) {
      var open = el.getAttribute('aria-expanded') === 'true';
      el.setAttribute('aria-expanded', String(!open));
      var panel = document.getElementById(el.getAttribute('aria-controls'));
      if (panel) panel.hidden = open;
      return;
    }

    /* Swatches de color */
    el = e.target.closest('[data-m-swatch]');
    if (el) {
      var group = el.closest('[data-m-swatches]');
      if (group) {
        $$('[data-m-swatch]', group).forEach(function (s) { s.setAttribute('aria-pressed', 'false'); });
        el.setAttribute('aria-pressed', 'true');
        var img = group.getAttribute('data-m-target') && document.getElementById(group.getAttribute('data-m-target'));
        var newSrc = el.getAttribute('data-m-image');
        if (img && newSrc) { img.src = newSrc; img.removeAttribute('srcset'); }
        var card = group.closest('[data-m-card]');
        var vid = el.getAttribute('data-m-variant');
        if (card && vid) card.setAttribute('data-m-variant', vid);
      }
      return;
    }


    /* Opción de producto (color, talla…) */
    el = e.target.closest('[data-m-option]');
    if (el) {
      var grp = el.parentElement;
      $$('[data-m-option]', grp).forEach(function (b) { b.setAttribute('aria-pressed', 'false'); });
      el.setAttribute('aria-pressed', 'true');
      var f = el.closest('[data-m-pdp-form]');
      if (f) pdpSync(f);
      return;
    }

    /* Miniatura de la galería */
    el = e.target.closest('[data-m-gallery-thumb]');
    if (el) {
      var hero = document.getElementById('m-pdp-hero-img');
      var src2 = el.getAttribute('data-m-image');
      if (hero && src2) { hero.src = src2; hero.removeAttribute('srcset'); }
      return;
    }

    /* Modal (guía de tallas) */
    el = e.target.closest('[data-m-open]');
    if (el) {
      var dlg = document.getElementById(el.getAttribute('data-m-open'));
      if (dlg && dlg.showModal) dlg.showModal();
      return;
    }
    if (e.target.closest('[data-m-close-modal]')) {
      var open = e.target.closest('dialog');
      if (open && open.close) open.close();
      return;
    }

    /* Selector de pack */
    el = e.target.closest('[data-m-pack]');
    if (el) {
      var list = el.closest('[data-m-packs]');
      if (list) {
        $$('[data-m-pack]', list).forEach(function (p) { p.setAttribute('aria-pressed', 'false'); });
        el.setAttribute('aria-pressed', 'true');
        var pdpForm = el.closest('[data-m-pdp-form]');
        if (pdpForm) {
          var sel = pdpForm.querySelector('[data-m-variant-select]');
          if (sel && el.getAttribute('data-m-variant')) sel.value = el.getAttribute('data-m-variant');
          var sid2 = pdpForm.id.replace('m-form-', '');
          var priceEl2 = document.getElementById('m-price-' + sid2);
          if (priceEl2 && el.getAttribute('data-m-price')) priceEl2.textContent = el.getAttribute('data-m-price');
          return;
        }
        var cta = document.getElementById(list.getAttribute('data-m-cta'));
        if (cta) {
          cta.setAttribute('data-m-variant', el.getAttribute('data-m-variant') || '');
          cta.setAttribute('data-m-label', el.getAttribute('data-m-label') || '');
          var priceOut = document.getElementById(list.getAttribute('data-m-price-out') || '');
          if (priceOut) priceOut.textContent = el.getAttribute('data-m-price') || '';
        }
      }
      return;
    }

    /* Añadir al carrito */
    el = e.target.closest('[data-m-add]');
    if (el) {
      e.preventDefault();
      var holder = el.closest('[data-m-card]') || el;
      var variant = el.getAttribute('data-m-variant') || holder.getAttribute('data-m-variant');
      addToCart(variant, el.getAttribute('data-m-qty') || 1, el.getAttribute('data-m-label') || holder.getAttribute('data-m-label'), el);
      return;
    }
  });

  document.addEventListener('keydown', function (e) {
    var d = $('#m-drawer');
    if (e.key === 'Escape' && d && !d.hidden) setDrawer(false);
  });

  /* ---------- Sticky CTA ------------------------------------------------ */
  function initSticky() {
    var bar = $('[data-m-sticky]');
    var mark = $('[data-m-sticky-after]');
    if (!bar || !mark || !('IntersectionObserver' in window)) return;
    new IntersectionObserver(function (entries) {
      var e = entries[0];
      bar.classList.toggle('is-on', !e.isIntersecting && e.boundingClientRect.top < 0);
    }, { threshold: 0 }).observe(mark);
  }

  /* ---------- Newsletter de demostración -------------------------------- */
  document.addEventListener('submit', function (e) {
    var f = e.target.closest('[data-m-demo-form]');
    if (!f) return;
    e.preventDefault();
    toast(f.getAttribute('data-m-success') || 'Listo.');
    f.reset();
  });


  /* ---------- Ficha de producto: opciones, galería y packs -------------- */
  function pdpCurrentOptions(form) {
    var out = [];
    $$('[data-m-option]', form).forEach(function (btn) {
      var i = Number(btn.getAttribute('data-m-option'));
      if (btn.getAttribute('aria-pressed') === 'true') out[i] = btn.getAttribute('data-m-value');
    });
    return out;
  }

  function pdpSync(form) {
    var select = form.querySelector('[data-m-variant-select]');
    if (!select) return;
    var wanted = pdpCurrentOptions(form).filter(function (x) { return x != null; }).join(' / ');
    var match = Array.prototype.find.call(select.options, function (o) {
      return (o.getAttribute('data-m-title') || o.text) === wanted;
    });
    if (!match) return;
    select.value = match.value;

    var sid = form.id.replace('m-form-', '');
    var price = document.getElementById('m-price-' + sid);
    var compare = document.getElementById('m-compare-' + sid);
    var off = document.getElementById('m-off-' + sid);
    if (price && match.getAttribute('data-m-price')) price.textContent = match.getAttribute('data-m-price');
    var cmp = match.getAttribute('data-m-compare');
    if (compare) compare.hidden = !cmp;
    if (compare && cmp) compare.textContent = cmp;
    if (off) off.hidden = !cmp;

    var img = document.getElementById('m-pdp-hero-img');
    var vimg = match.getAttribute('data-m-image');
    if (img && vimg) { img.src = vimg; img.removeAttribute('srcset'); }

    var buy = document.getElementById('m-buy-' + sid);
    if (buy) {
      buy.disabled = match.disabled;
      buy.textContent = match.disabled ? 'Agotado' : (buy.getAttribute('data-m-label-default') || buy.textContent);
    }

    $$('[data-m-option-out]', form).forEach(function (el) {
      var i = Number(el.getAttribute('data-m-option-out'));
      var val = pdpCurrentOptions(form)[i];
      if (val) el.textContent = val;
    });
  }

  /* Envío del formulario de producto por AJAX */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-m-pdp-form]');
    if (!form) return;
    e.preventDefault();
    var select = form.querySelector('[data-m-variant-select]');
    var qty = form.querySelector('input[name="quantity"]');
    var btn = form.querySelector('button[type="submit"]');
    var label = form.closest('section') ? (form.closest('section').querySelector('h1') || {}).textContent : '';
    addToCart(select && select.value, qty ? qty.value : 1, (label || 'producto').trim(), btn);
  });

  /* ---------- Arranque -------------------------------------------------- */
  function boot() { initSticky(); refreshCartCount(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  /* El Theme Editor recarga secciones sueltas: reenganchamos lo que hace falta */
  document.addEventListener('shopify:section:load', boot);

  window.Monaro = { toast: toast, addToCart: addToCart, refreshCartCount: refreshCartCount };
})();
